import { type ReactNode } from 'react';
import { TrendingUp } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';
import { useActivePricing, type Tier } from '@/hooks/use-pricing';

function formatRange(tier: Tier): string {
  if (tier.max === null) return `${tier.min}+ creators/día`;
  return `${tier.min}–${tier.max} creators/día`;
}

function TierRow({ tier }: { tier: Tier }): ReactNode {
  return (
    <div className="flex items-center justify-between border-b border-white/[0.04] py-sm last:border-0">
      <span className="text-xs text-text-secondary">{formatRange(tier)}</span>
      <span className="font-mono text-xs font-medium text-text-primary">
        ${tier.price_per_lead.toFixed(2)}
      </span>
    </div>
  );
}

export function PricingTiersReadonly(): ReactNode {
  const { data, isLoading } = useActivePricing();
  if (isLoading) return <Skeleton className="h-32 rounded-xl" />;
  if (!data) return null;
  return (
    <div className="rounded-xl bg-white/[0.02] p-base">
      <div className="flex items-center gap-sm">
        <TrendingUp size={14} className="text-info" />
        <p className="text-[10px] font-medium uppercase tracking-wider text-text-tertiary/60">
          Tabla de precios por creator
        </p>
      </div>
      <div className="mt-sm">
        {data.tiers.map((t) => (
          <TierRow key={t.min} tier={t} />
        ))}
      </div>
    </div>
  );
}
